<div class="frame-in">
  @if (data) {
    <div [ngClass]="{'hidden': loading}">
      <div class="introduction" [ngClass]="{'hidden':!(!gameStatus || gameStatus == 'introduction')}">
        <h2 class="title">
          <span class="main-text">{{data.introduction.title}}</span>
          <span class="bg-text">{{data.introduction.title}}</span>
        </h2>
        <p class="text">{{data.introduction.text}}</p>
        <button type="button" class="introduction-button" (click)="gameStart()"></button>
        <button type="button" class="introduction-audio-button"  [ngClass]="{'ios': ios && !userTouch}" (click)="playIntroductionAudio()"></button>
      </div>
      <div class="drag-drop" [ngClass]="{'hidden':!(gameStatus && gameStatus == 'start')}" (click)="true">
        <div class="stars-box">
          @for (item of data.data.letters; track item; let index = $index) {
            <div class="star" [ngClass]="stars[index]">
            </div>
          }
        </div>
        <button type="button" class="leave-button" (click)="changeGameStatus('leave')"></button>
        <div class="fail-box">
          <div class="fail" [ngClass]="{'active': failCount > 0}"></div>
          <div class="fail" [ngClass]="{'active': failCount > 1}"></div>
          <div class="fail" [ngClass]="{'active': failCount > 2}"></div>
        </div>
        <div class="books_list" id="all" cdkDropList [cdkDropListData]="data.data.letters"
          (cdkDropListDropped)="drop($event)"
          [cdkDropListConnectedTo]="['bookcase1', 'bookcase2', 'bookcase3', 'bookcase4', 'bookcase5', 'bookcase6']">
          @for (item of data.data.letters; track item) {
            <ng-container (pointerDown)="true">
              @if (!item?.set) {
                <div class="drag-drop-book" [cdkDragData]="item" (cdkDragStarted)="drag($event)"
                  cdkDrag><span>{{item.letter}}</span></div>
                }
                <audio id="audio-{{item.uid}}">
                  <source [src]="item.audio" type="audio/wav">
                </audio>
              </ng-container>
            }
          </div>
          <div class="bookcases">
            @for (item of photoArray | randomSort; track item; let i = $index) {
              <div class="bookcase" cdkDropList
                [id]="'bookcase'+(i+1)" cdkDropListConnectedTo="all" (cdkDropListDropped)="drop($event)"
                [cdkDropListData]="item.uid">
                <input type="hidden" class="hidden-letter" [value]="item.uid">
                <div class="title">
                  <img [src]="item.image">
                </div>
                @if (item.set) {
                  <div class="target">
                    <div class="drag-drop-book in-target" [ngClass]="{'set-in': item.set}">
                      <span>{{item.set?item.letter:''}}</span>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="leave" [ngClass]="{'hidden':!(gameStatus && gameStatus == 'leave')}">
          <p class="text">{{data.leave.text}}</p>
          <div class="row justyfy-content-center">
            <div class="col-auto">
              <button type="button" class="leave-yes" (click)="previousState()"></button>
            </div>
            <div class="col-auto">
              <button type="button" class="leave-no" (click)="gameStart()"></button>
            </div>
          </div>
        </div>
        <div class="complete" [ngClass]="{'hidden':!(gameStatus && gameStatus == 'complete')}">
          <div class="trophy"></div>
          <div class="total-score">{{userInfo?.totalScore}}</div>
          <div class="stars">+{{collectPoints}}</div>
          <button type="button" class="back-to-menu" (click)="previousState()"></button>
          <button type="button" class="again" (click)="playAgain()"></button>
          <button type="button" class="next-activity" (click)="nextActivity()"></button>
        </div>
        <div class="try-again" [ngClass]="{'hidden':!(gameStatus && gameStatus == 'try-again')}">
          <div class="fail-star"></div>
          <div class="total-score">{{userInfo?.totalScore}}</div>
          <div class="stars">+0</div>
          <button type="button" class="back-to-menu" (click)="previousState()"></button>
          <button type="button" class="again" (click)="playAgain()"></button>
        </div>
        <audio id="faileAudio">
          <source [src]="data.tryAgainAudios[data.tryAgainAudios.length | randomIndex]" type="audio/wav">
        </audio>
        <audio id="introductionAudio" (loadeddata)="instructionLoaded()">
          <source [src]="data.introduction.audio" type="audio/wav">
        </audio>
        <audio id="warningAudio">
          <source src="assets/sounds/warning.mp3" type="audio/mpeg">
        </audio>
        <audio id="completeAudio">
          <source [src]="data.completeAudios[data.completeAudios.length | randomIndex]" type="audio/wav">
        </audio>
        <audio id="faileDrop">
          <source src="assets/sounds/wrong-drop.mp3" type="audio/mpeg">
        </audio>
        <audio id="successDrop">
          <source src="assets/sounds/correct-drop.mp3" type="audio/mpeg">
        </audio>
        <audio id="drag">
          <source src="assets/sounds/drag.mp3" type="audio/mpeg">
        </audio>
        <img class="frame-bg" src="assets/images/activity/introduction/introduction-bg.jpg" [ngClass]="{'hidden':gameStatus && gameStatus !== 'introduction'}">
        <img class="frame-bg" src="assets/images/activity/dragDrop/drag-drop-bg.jpg" [ngClass]="{'hidden': !gameStatus || gameStatus !== 'start'}">
        <img class="frame-bg" src="assets/images/activity/complete/complete-bg.png" [ngClass]="{'hidden':!gameStatus || gameStatus !== 'complete'}">
        <img class="frame-bg" src="assets/images/activity/leave/leave-bg.png" [ngClass]="{'hidden':!gameStatus || gameStatus !== 'leave'}">
        <img class="frame-bg" src="assets/images/activity/try-again/try-again-bg.jpg" [ngClass]="{'hidden':!gameStatus || gameStatus !== 'try-again'}">
      </div>
    }
  </div>